const DISCORD_SUPPORT_URL = 'https://discord.gg/playcast';

interface DiscordSupportLinkProps {
  className?: string;
}

export const DiscordSupportLink = ({ className = '' }: DiscordSupportLinkProps) => (
  <a
    href={DISCORD_SUPPORT_URL}
    target='_blank'
    rel='noopener noreferrer'
    className={`text-sm text-[#FBBF24] underline transition-opacity hover:opacity-80 ${className}`}
  >
    Need help? Join our Discord
  </a>
);

export const FrozenCallout = () => (
  <div
    className='w-full text-center'
    style={{
      padding: '8px 12px',
      borderRadius: 8,
      background: 'rgba(184, 0, 73, 0.2)',
      border: '1.5px solid rgba(252, 107, 131, 0.56)',
      boxSizing: 'border-box',
    }}
  >
    <p className='text-[12px] font-semibold text-white' style={{ letterSpacing: 0.6 }}>FROZEN</p>
    <p className='mt-1 text-[11px] text-[#FFFFFF]/60' style={{ lineHeight: 1.3 }}>
      Your rewards account has been frozen
    </p>
    <a
      href={DISCORD_SUPPORT_URL}
      target='_blank'
      rel='noopener noreferrer'
      className='mt-1 inline-block text-[11px] text-[#87C3FF] underline'
      style={{ textUnderlineOffset: 2, textDecorationColor: 'rgba(135, 195, 255, 0.5)' }}
    >
      Contact Support on Discord
    </a>
  </div>
);

interface ErrorModalProps {
  title: string;
  message: string;
  claimId?: string;
  onRetry?: () => void;
  onDismiss: () => void;
}

export const ErrorModal = ({ title, message, claimId, onRetry, onDismiss }: ErrorModalProps) => (
  <div className='fixed inset-0 z-50 flex items-center justify-center bg-black/60'>
    <div className='mx-4 w-full max-w-[310px] rounded-lg border border-[#991B1B] bg-[#0F172A] p-5'>
      <h3 className='mb-2 text-lg font-semibold text-[#FCA5A5]'>{title}</h3>
      <p className='mb-3 whitespace-pre-line text-sm text-[#FFFFFF]/80'>{message}</p>
      {claimId && (
        <p className='mb-3 text-xs text-[#FFFFFF]/70'>
          Claim ID: {claimId}
        </p>
      )}
      <div className='flex flex-col items-center gap-2'>
        {onRetry && (
          <button
            type='button'
            onClick={onRetry}
            className='w-full rounded-full bg-[#FBBF24] px-6 py-2 text-sm font-semibold text-[#020617] transition-transform hover:scale-[1.02] active:scale-[0.98]'
          >
            Try Again
          </button>
        )}
        <button
          type='button'
          onClick={onDismiss}
          className='w-full rounded-full border border-[#FFFFFF]/20 px-6 py-2 text-sm font-medium text-[#FFFFFF]/80 transition-opacity hover:opacity-80'
        >
          Dismiss
        </button>
        <DiscordSupportLink className='mt-1' />
      </div>
    </div>
  </div>
);
